/* eslint-disable react/no-unknown-property */
import { LOCALE } from '@foxrenderfarm/internals'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import React from 'react'

interface Props {
  title: string
  keywords?: string
  description: string
  type?: string
  shareImgSrc?: string
  sharePostSlug?: string
  isHasImgOrigin?: boolean
  twitterShareImgSrc?: string
  lang: LOCALE
}

export const Seo = ({
  title = '',
  keywords = '',
  description = '',
  type = 'article',
  shareImgSrc,
  sharePostSlug = '',
  isHasImgOrigin = false,
  twitterShareImgSrc,
  lang = LOCALE.EN,
}: Props) => {
  const [origin, setOrigin] = useState('https://www.foxrenderfarm.com')
  // const origin = 'https://foxrenderfarm.com'

  useEffect(() => {
    if (window.location) {
      setOrigin(window.location.origin)
    }
  }, [])

  const shareImg = shareImgSrc
    ? `${isHasImgOrigin ? '' : origin}${shareImgSrc}`
    : `${origin}/foxrenderfarm.png`

  return (
    <Helmet title={title} htmlAttributes={{ lang: lang }}>
      <meta http-equiv='X-UA-Compatible' content='IE=edge,chrome=1' />
      <meta name='renderer' content='webkit' />
      <meta name='keywords' content={keywords} />
      <meta name='description' content={description} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content={type} />
      <meta property='og:image' content={shareImg} />
      <link
        rel='canonical'
        href={`${origin}/${lang && lang !== 'en' ? `${lang}/` : ''}${sharePostSlug}`}
      />
      <meta
        property='og:url'
        content={`${origin}/${lang && lang !== 'en' ? `${lang}/` : ''}${sharePostSlug}`}
      />
      <meta property='og:image:width' content='400' />
      <meta property='og:image:height' content='300' />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:site' content='@foxrenderfarm' />
      <meta name='twitter:creator' content='@FoxRenderfarm' />
      <meta name='twitter:title' content={title} />
      <meta
        name='twitter:image'
        content={twitterShareImgSrc ? `${origin}${twitterShareImgSrc}` : shareImg}
      />
      <meta name='twitter:description' content={description} />
    </Helmet>
  )
}
